import React, { ReactElement } from "react";

import Background from "../media/Logo-Slogan-englisch.png";
import Stefan from "../media/Stefan.jpg";
import Felix from "../media/Felix.jpeg";

import styled from "styled-components";

export default function Info(): ReactElement {
  return (
    <Container>
      <div className="info-content-header center">
        <b>APC-Analyzer</b>
      </div>
      <div className="center" style={{ fontSize: "35px", flex: 0.15 }}>
        made by
      </div>
      <div
        className="center"
        style={{
          marginTop: "20px",
          marginBottom: "30px",
        }}
      >
        <img src={Background} alt="" width="200px" height="100px" />
      </div>
      <div className="info-para">
        <div className="text-center">
          in cooperation with Felix Fischer, head of the Power Lab at Fraunhofer
          Institute for Reliability and Microintegration
        </div>
      </div>
      <div className="info-company">
        <p>
          Bond-IQ GmbH offers solutions for wire bonding processes, trainings
          and a wide range of support for process, engineering and failure
          analysis. Find our more:
          <br />
          <a href="https://www.bond-iq.de/" target="_blank" rel="noreferrer">
            www.bond-iq.de
          </a>
        </p>
        <p>
          For the tests of power components or overall systems Felix and his
          team at the power lab designs client-specific test conditions and
          settings. Automated test systems are used to carry out life-time
          studies by active power cycling in accordance with automotive standard
          AQG 324. Find our more:
          <br />
          <a
            href="https://www.izm.fraunhofer.de/en/abteilungen/environmental_reliabilityengineering/equipment/powerlab.html"
            target="_blank"
            rel="noreferrer"
          >
            Power Lab
          </a>
        </p>
        <div className="images">
          <figure>
            <img className="avatar" src={Stefan} alt="Bond-IQ" width={250} />
            <figcaption style={{ textAlign: "center" }}>
              <strong>Stefan Schmitz</strong>
              <br />
              CEO of Bond-IQ
            </figcaption>
          </figure>
          <figure>
            <img className="avatar" src={Felix} alt="Power Lab" width={250} />
            <figcaption style={{ textAlign: "center" }}>
              <strong>Felix Fischer</strong>
              <br />
              Head of Power Lab
            </figcaption>
          </figure>
        </div>

        <div className="center">
          <a
            href="https://bond-iq.de/impressum/"
            target="_blank"
            rel="noreferrer"
          >
            Impressum
          </a>
        </div>
      </div>
    </Container>
  );
}

const Container = styled.div`
  flex: 0.5;
  background-color: #eeeeee;
  padding: 20px;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  @media (max-width: 1200px) {
    .images {
      flex-direction: column;
    }

    .avatar {
      display: flex;
      justify-content: center;
      margin: auto;
    }
  }

  .images {
    display: flex;
    justify-content: center;
    gap: 40px;
  }

  .info-content-header {
    color: #9a1915;
    font-size: 40px;
    flex: 0.2;

    @media (min-width: 750px) {
      font-size: 60px;
    }

    @media (min-width: 1000px) {
      font-size: 65px;
    }

    @media (min-width: 1500px) {
      font-size: 70px;
    }
  }

  .center {
    display: flex;
    justify-content: center;
  }

  .info-para {
    font-size: 25px;

    @media (min-width: 1000px) {
      font-size: 35px;
    }

    & div {
      display: flex;
      justify-content: center;
    }
  }

  .info-company {
    margin-top: 4vh;
    font-size: 12px;

    & p {
      padding: 0 20px;
    }

    @media (min-width: 750px) {
      font-size: 15px;
    }

    @media (min-width: 1000px) {
      font-size: 15px;
    }
    @media (min-width: 1200px) {
      font-size: 20px;
    }
  }
`;
